/**
 * Fetch Path Viewer State API (v2)
 * GET /api/learning-paths/{pathId}/viewer-state
 *
 * Returns server-computed step/item statuses (ProgressionEngine), real
 * completion timestamps and the resume pointer. The response is rendered
 * verbatim — no client-side transformation.
 */

import axiosInstance from "../axiosInstance";
import type { ViewerState } from "@/modules/learningCenter/features/LearningPathViewer/types/viewerState";

interface ViewerStateEnvelope {
  data: ViewerState;
}

/**
 * Fetches the viewer state for a specific learning path
 * @param pathId - ID of the learning path
 * @returns Viewer state with steps, edges, enrollment and progress
 */
export const fetchPathViewerState = async (
  pathId: number,
): Promise<ViewerState> => {
  const response = await axiosInstance.get<ViewerStateEnvelope>(
    `/api/learning-paths/${pathId}/viewer-state`,
  );

  return response.data.data;
};
